import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

export const PTO_PHASE_TWO_SPOTLIGHT_TARGET = keys.PTO_PHASE_TWO_SPOTLIGHT_TARGET;

export const getIsPremiumOnboardingHappened = (initialLoading = false): boolean => {
	return initialLoading
		? localStorage.getItem(PTO_PHASE_TWO_SPOTLIGHT_TARGET) === null
		: localStorage.getItem(PTO_PHASE_TWO_SPOTLIGHT_TARGET) === 'false';
};

export const setIsPremiumOnboardingHappened = (isPremiumOnboardingHappened: boolean): boolean => {
	try {
		localStorage.setItem(PTO_PHASE_TWO_SPOTLIGHT_TARGET, String(isPremiumOnboardingHappened));
		return true;
	} catch (err) {
		return false;
	}
};
